import { TextField } from '@mui/material';
import React from 'react';

const SectionSearchBar = ({ onSearch }) => {
  const handleChange = (e) => onSearch(e.target.value);
  return (
    <TextField
      label="Pesquisar Seção"
      variant="outlined"
      fullWidth
      size="small"
      onChange={handleChange}
      style={{ marginBottom: 16 }}
    />
  );
};

export default SectionSearchBar;
